module.exports = __webpack_public_path__ + "img/right_bg.c64073e.png";